import {pushEdapEvent} from '../../../../utils/edap';

export function pushTopVisibleEvent() {
    pushEdapEvent('content_module.presented', {
        action_location: 'sticky search form',
        position_fired: 'top',
    });
}

export function pushBottomVisibleEvent() {
    pushEdapEvent('content_module.presented', {
        action_location: 'sticky search form',
        position_fired: 'bottom',
    });
}
